import type { ComponentType } from "react"
import { Link } from "@tanstack/react-router"

// Mirrors HOME_TILE_CLASS geometry so an add tile lines up with the real tiles
// beside it; the dashed edge is what marks it as a slot rather than an article.
const ADD_TILE_CLASS =
	"group relative flex cursor-default flex-col items-stretch overflow-hidden rounded-lg border border-dashed border-gray-300 bg-black/[0.02] text-left hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-850 dark:hover:bg-gray-800"

export const DocsAddTile = ({
	Icon,
	title,
	description,
	onClick,
	to,
}: {
	Icon: ComponentType<{ className?: string }>
	title: string
	description: string
	onClick?: () => void
	to?: string
}) => {
	const body = (
		<>
			<div className="border-b border-dashed border-gray-300 px-3 pb-5 pt-5 sm:pb-10 lg:px-[1.2rem] dark:border-gray-700">
				<div className="flex h-6 w-6 items-center justify-center">
					<Icon className="size-[18px] flex-none text-tertiary" />
				</div>
			</div>
			<div className="px-3 pb-5 pt-4 lg:px-[1.2rem]">
				<h3 className="line-clamp-1 min-w-0 text-ellipsis text-[0.9rem] font-medium tracking-tight text-primary">
					{title}
				</h3>
				<p className="mt-1 line-clamp-2 min-w-0 overflow-hidden text-ellipsis text-[0.8rem] tracking-tight text-gray-500 opacity-90 dark:text-gray-400">
					{description}
				</p>
			</div>
		</>
	)

	if (to) {
		return (
			<Link to={to} className={ADD_TILE_CLASS}>
				{body}
			</Link>
		)
	}

	return (
		<button type="button" onClick={onClick} className={ADD_TILE_CLASS}>
			{body}
		</button>
	)
}
